import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import MessagesInbox from '@efdigital/ll-xceed-v2/components/coaching/messaging/messages-inbox.gts';
import type { CoachingCoachMessagesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/messages';
import type { TOC } from '@ember/component/template-only';

interface MessagesIndexSignature {
  Args: {
    model: CoachingCoachMessagesModel;
    controller: unknown;
  };
}

<template>
  <MessagesInbox
    @conversations={{@model.conversations}}
    @role="coach"
    @searchInputId="coachMessengerSearchMobile"
    class="h-100 d-lg-none coaching-messages-mobile-inbox"
  />
  <div
    class="d-none d-lg-flex h-100 align-items-center justify-content-center p-4"
  >
    <EmptyState
      @icon="ph:chat-circle"
      @message="Select a conversation to read and send messages."
    />
  </div>
</template> satisfies TOC<MessagesIndexSignature>;
